import { PathContext } from "library/show/components/path/state/PathProvider"
import { useContext, useEffect, useRef, useState } from "react"

export const usePathLoading = () => {
  const { loaded } = useContext(PathContext)

  const timeoutRef = useRef(null)
  const [pathFailingToLoad, setPathFailingToLoad] = useState(false)

  const isWaitingForPath = !loaded // TODO?: || path && path.user !== currentUser

  const clearTimeout = () => clearInterval(timeoutRef.current)

  useEffect(() => {
    if (isWaitingForPath) {
      timeoutRef.current = setTimeout(() => {
        if (isWaitingForPath) setPathFailingToLoad(true)
      }, 15000)
    } else {
      clearTimeout()
    }
  }, [isWaitingForPath])

  useEffect(() => clearTimeout, [])

  return { isWaitingForPath, pathFailingToLoad }
}
